import ErrorImage from '../../Assets/Images/errors/404.svg';

const ErrorPage = ({ code = 404, children }: any) => (
  <div className="error-page">
    <div className="item">
      <img src={ErrorImage} alt={'page not found'} />
      <div className="text">
        <h1 className="error-page-code">{code}</h1>
        {children}
      </div>
    </div>
  </div>
);

export default ErrorPage;
